import React, { ReactNode } from 'react'
import { IconLocationPin } from '@s4l/icons/IconLocationPin'
import { IconBullet } from '@s4l/icons/IconBullet'

import Typography from '../Typography'

import styles from './index.module.css'

export interface IAddressProps {
  children: ReactNode
  size: 's' | 'l'
  center?: boolean
  i18n?: {
    inCenter?: string
    fromCenter?: string
  }
}

export default function Address(props: IAddressProps) {
  const { children, size, center, i18n } = props

  const typographySize = size === 'l' ? 'l' : 'm'

  const centerText =
    // eslint-disable-next-line no-nested-ternary
    center !== undefined || i18n ? (center ? i18n?.inCenter : i18n?.fromCenter) : null

  return (
    <address className={styles.container}>
      <IconLocationPin size={16} className={styles.locationPin} />
      <Typography variant="caption" size={typographySize} clamp={1}>
        {children}
        {centerText && (
          <>
            <IconBullet size={16} className={styles.bullet} data-testid="bullet" />
            {centerText}
          </>
        )}
      </Typography>
    </address>
  )
}
